import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import { CompanySetUpTabHash } from 'enums/CompanySetupEnums';
import React, { FC } from 'react';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import useRedirect from 'shared/utils/useRedirect';
import styles from './processingFacilityModal.module.scss';

interface ProcessingFacilityModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  contentText?: string;
}

const ProcessingFacilityModal: FC<ProcessingFacilityModalProps> = ({
  modalOpen,
  handleClose,
  contentText,
}) => {
  const { redirectToCompanySetUp, redirectToAddLocations } = useRedirect();
  const { organizationData } = useParentOrganizationContext();
  const hanldeProductRedirection = () => {
    if (!organizationData?.organization?.name) {
      redirectToCompanySetUp(CompanySetUpTabHash.LOCATIONS)();
    } else {
      redirectToAddLocations({ isProcessingFacility: true });
    }
  };
  const infoText =
    contentText ??
    `Please create a processing facility before creating a product`;
  return (
    <OrganizationModal
      visible={modalOpen}
      onClose={handleClose}
      width={400}
      children={
        <div className={styles.createProductContainer}>
          <div className={styles.createProductTitleContainer}>{infoText}</div>
          <div className={styles.buttonContainer}>
            <COButton
              primary
              children="Create"
              onClick={hanldeProductRedirection}
            />
            <COButton secondary children="Back" onClick={handleClose} />
          </div>
        </div>
      }
    />
  );
};

export default ProcessingFacilityModal;
